import { TENANTS_NAMES } from './host_config';

const defaultEnvironmentVariables = {
  API_URL: process.env.REACT_APP_ACME_API_URL,
  ONTRUCK_AUTH_CLIENTID: process.env.REACT_APP_TENANT_AUTH_CLIENTID,
  GOOGLE_MAPS_KEY: process.env.REACT_APP_TENANT_GOOGLE_MAPS_KEY,
  DEFAULT_STRIPE_KEY: process.env.REACT_APP_TENANT_STRIPE_KEY,
  STRIPE_KEY: {
    ES: process.env.REACT_APP_TENANT_STRIPE_KEY,
    UK: process.env.REACT_APP_TENANT_STRIPE_KEY_UK,
    FR: process.env.REACT_APP_TENANT_STRIPE_KEY_FR,
    NL: process.env.REACT_APP_TENANT_STRIPE_KEY_NL,
  },
  SENTRY_DSN: process.env.REACT_APP_TENANT_SENTRY_DSN,
  OFFER_LINKS: {
    ES: 'https://info.ontruck.com/hubfs/Cobertura%20geogr%C3%A1fica/2022%20Cobertura%20geogr%C3%A1fica%20servicios%20ES.pdf',
    FR: 'https://info.ontruck.com/hubfs/Cobertura%20geogr%C3%A1fica/2023%20Couverture%20G%C3%A9ographique%20FR.pdf',
    UK: '',
    NL: '',
  },
  LH_EXPRESS_LINK:
    'https://info.ontruck.com/hubfs/Sales%20Collaterals/One%20Pagers/es-one-pager-LH-ontruck-2022.pdf',
};

const environmentVariableByTenant = {
  [TENANTS_NAMES.intraser]: {
    HOTJAR: process.env.REACT_APP_TENANT_INTRASER_HOTJAR,
  },
};

const fetchEnvironmentVariables = (tenantName = null) => {
  const tenantEnvVariables =
    tenantName in environmentVariableByTenant
      ? environmentVariableByTenant[tenantName]
      : {};
  return { ...defaultEnvironmentVariables, ...tenantEnvVariables };
};

export { fetchEnvironmentVariables };
